import {shallowEqual, useSelector} from 'react-redux';
import {Picture} from '~library/atoms/Picture';
import {Link} from '~library/atoms/Link';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {useIsLargishAndUp} from '~/common/hooks/useMatchQuery';
import {Header} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/components/Header/Header';
import {selectGuestsOfHonor, selectHostName} from '~/ViewInvitation/selectors/eventDetails';
import {selectGiftingData} from '~/ViewInvitation/selectors/gifting';
import {Step} from '~/ViewInvitation/common/RSVPModalVariantAB/steps/components/Step/Step';

import './GiftIdeas.sass';

type GiftIdeasProps = {
  onCloseClick: () => void;
};

export const GiftIdeas = ({onCloseClick}: GiftIdeasProps) => {
  const giftingData = useSelector(selectGiftingData, shallowEqual);
  const vendorName = giftingData.vendorName.toLowerCase().replace(' ', '-');
  const guestsOfHonor = useSelector(selectGuestsOfHonor);
  let giftIdeaStepTitle = useSelector(selectHostName);
  const isLargishAndUp = useIsLargishAndUp();
  const description = 'Not sure where to begin? No worries—browse Evite’s suggested gifts.';

  if (guestsOfHonor.length >= 1) {
    giftIdeaStepTitle = guestsOfHonor.join(' and ');
  }

  return (
    <Step
      header={
        <Header onClose={onCloseClick} title={`Start browsing gifts for ${giftIdeaStepTitle}`} />
      }
      description={isLargishAndUp ? description : ''}
      footer={
        <>
          <Link
            as="primary"
            data-impression-tracking="true"
            data-qa-id={`af-rsvp-gifting-${vendorName}-btn`}
            href={giftingData.url}
            target="_blank"
          >
            Find the perfect gift
          </Link>
          <Button
            variant="secondary"
            size="large"
            data-qa-id={`af-rsvp-gifting-${vendorName}-skip`}
            onClick={onCloseClick}
            className="rsvp-step__footer__cta"
          >
            Maybe later
          </Button>
        </>
      }
    >
      <Link
        href={giftingData.url}
        target="_blank"
        data-qa-id={`af-rsvp-gifting-${vendorName}-disc`}
        className="rsvp__gift-ideas__disc-container"
      >
        <Picture
          srcSet={giftingData.iconUrl}
          className="rsvp__gift-ideas__disc-image"
          alt="Vendor Image"
        />
      </Link>

      {!isLargishAndUp && (
        <Typography variant="paragraph2" color="charcoal">
          {description}
        </Typography>
      )}
    </Step>
  );
};
